import { Component, OnInit, Input, ViewContainerRef } from '@angular/core'
import { AlgBillModalComponent } from '../../dialogs/alg-bill-modal/alg-bill-modal.component';
import { UtilsService } from '../../../services/utils.service';
import { ModalDialogService } from 'ngx-modal-dialog';
import { AlgSocioModalComponent } from '../../dialogs/alg-socio-modal/alg-socio-modal.component';
import { Product, Source} from '../../../models/product';
import { ApiService } from '../../../services/api.service';
import { AlgGtmService } from "../../../services/alg-gtm.service";

@Component({
  selector: 'alg-header-details',
  templateUrl: './alg-header-details.component.html',
  styleUrls: ['./alg-header-details.component.scss']
})
export class AlgHeaderDetailsComponent implements OnInit {
  public currentProduct: Product;
  public isUniquePayment: boolean = null;
  public isAccendiUnicaCoop :boolean

 @Input() power: string;

  constructor(
    private utils: UtilsService,
    private modalDialogService: ModalDialogService,
    private viewContainer: ViewContainerRef,
    private api: ApiService,
    private gtm: AlgGtmService
  ) { }

  ngOnInit() {
    this.api.currentOnboarding.combineLatest(
      this.api.currentProduct
    ).subscribe(([onboarding, product]) => {
      this.controlPayment();
      this.currentProduct = product;
      console.log('currentProduct', this.currentProduct);
      if(this.currentProduct.family) {
        if (this.currentProduct.family.productSource == Source.accendiUnicaCoop) {
          this.isAccendiUnicaCoop = true;
        } else {
          this.isAccendiUnicaCoop = false;
        }
      }

    });
  }

  controlPayment(){
    if(this.currentProduct && !!this.currentProduct.family && !this.currentProduct.family.bollettinoDisabled) return this.isUniquePayment = false;

    if(this.currentProduct && !!this.currentProduct.family && !this.currentProduct.family.ridDisabled) return this.isUniquePayment = true
  }

  showFirstModal(){
    this.gtm.submitOnbEvent('Visualizzazione modale','La tua bolletta')
    this.utils.disableOverflow();
    this.modalDialogService.openDialog(this.viewContainer, {
      title: `La tua bolletta: `,
      childComponent: AlgBillModalComponent ,
      settings: {
        bodyClass       : 'modal-body',
        modalDialogClass: 'modal-dialog',
        closeButtonClass: 'close theme-icon-close',
        headerTitleClass: 'modal-title modal-title-underline'
      }
    });
  }

  showSecondModal(){
    this.gtm.submitOnbEvent('Visualizzazione modale','La tua tessera Socio');
    this.utils.disableOverflow();
    this.modalDialogService.openDialog(this.viewContainer, {
      title: `Se sei socio Coop, la tua tessera Socio: `,
      childComponent: AlgSocioModalComponent ,
      settings: {
        bodyClass       : 'modal-body',
        modalDialogClass: 'modal-dialog',
        closeButtonClass: 'close theme-icon-close',
        headerTitleClass: 'modal-title modal-title-underline'
      }
    });
  }


}



// WEBPACK FOOTER //
// ./src/app/components/atoms/alg-header-details/alg-header-details.component.ts